<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <!-- Nombre de pages -->
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Nbr page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"/>
            </b-form-group>
          </b-col>

          <!-- Tri des colonnes -->
          <b-col md="4" sm="8" class="my-1">
            <b-form-group label="Trier" label-cols-sm="3" label-align-sm="right" label-size="sm"
                          label-for="sortBySelect" class="mb-0">
              <b-input-group size="sm">
                <b-form-select id="sortBySelect" v-model="sortBy" :options="sortOptions" class="w-75">
                  <template v-slot:first>
                    <option value="">-- Vide --</option>
                  </template>
                </b-form-select>
                <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">

                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <!-- Filtre -->
          <b-col md="6" class="my-1">
            <b-form-group label="Filtrer" label-cols-sm="3" label-align-sm="right" label-size="sm"
                          label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher"
                              @input="fetchUsers"/>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>


          <b-col cols="12">

            <b-row class="align-items-center mb-1">
              <b-col cols="12" md="4" class="mb-1 mb-md-0">
                <label class="mb-0">Direction</label>
                <v-select
                    v-model="selectedDirections"
                    :options="directionOptions"
                    label="name"
                    placeholder="Toutes les directions"
                    class="filter-selector"

                />
              </b-col>

              <b-col cols="12" md="4" class="mb-1 mb-md-0">
                <label class="mb-0">Service</label>
                <v-select
                    v-model="selectedServices"
                    :options="serviceOptions"
                    label="name"
                    placeholder="Tous les services"
                    class="filter-selector"
                />
              </b-col>

              <b-col cols="12" md="4" class="mb-1 mb-md-0">
                <label class="mb-0">péage</label>
                <v-select
                    v-model="selectedToll"
                    :options="tollOptions"
                    label="name"
                    placeholder="Tous les péage"
                    class="filter-selector"
                />
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <hr>
            <b-row class="align-items-center mb-1">
              <b-col md="6" class="d-flex">

                <b-form-checkbox md="4" class="my-1 custom-control-primary" v-model="filtreInclure"
                                 switch inline>
                  {{ filtreInclure ? "Objectif requis" : "Objectif non requis" }}
                </b-form-checkbox>

                <b-form-checkbox md="4" class="my-1 custom-control-success" v-model="filtreInclureAuto" switch inline>
                  {{ filtreInclureAuto ? "Évaluation requise" : "Évaluation non requise" }}
                </b-form-checkbox>
                <b-form-checkbox md="4" class="my-1  custom-control-secondary" v-model="disabled" switch inline>
                  {{ disabled ? "Actif" : "Désactivé" }}
                </b-form-checkbox>
              </b-col>

              <b-col md="6" class="d-flex justify-content-end">
                <b-button variant="primary" :to="{ name: 'ajouter-user' }" class="mr-2">
                  Ajouter
                </b-button>
                <b-button variant="primary" @click="openAddModal">
                  Importer
                </b-button>
                <b-button class="ml-1" variant="primary" @click="exportUsers">
                  Exporter
                </b-button>
              </b-col>
            </b-row>
          </b-col>



          <b-col cols="12">

            <b-table striped hover responsive :items="users" :fields="tableColumns" :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc" @filtered="onFiltered" style="min-width: 100%">

              <template #head(objectif)="data">
                <b-form-checkbox
                    v-model="allSelected"
                    class="custom-control-primary"
                    @change="toggleAll"
                />

              </template>

              <template #cell(objectif)="data">
                <b-form-checkbox
                    v-model="data.item.checked"
                    class="custom-control-primary"
                    @change="onChangeObjectif(data.item)"

                />

              </template>


              <template #head(evaluation)="data">

                <b-form-checkbox
                    v-model="allSelectedAutoEvaluation"
                    class="custom-control-success"
                    @change="toggleAllAutoE"
                />
              </template>

              <template #cell(evaluation)="data">
                <b-form-checkbox
                    v-model="data.item.checkedAutoEvaluation"
                    class="custom-control-success"
                    @change="onChangeAutoEvaluation(data.item)"

                />
              </template>
              <!-- Cellule utilisateur -->
              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                      {{ getUserInitials(data.item) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.lastName }} {{ data.item.firstName }}
                  </span>
                  <small class="text-muted">{{ data.item.mail }}</small>
                </b-media>
              </template>

              <!-- Autres colonnes personnalisées -->
              <template #cell(fonction)="data">
                <span class="font-weight-bold d-block text-nowrap">
                  {{ data.item.fonction }}
                </span>
                <small class="text-muted" v-if="data.item.firstManagerFullName">{{
                    data.item.firstManagerFullName ? "Manager : " + data.item.firstManagerFullName : 'N/A'
                  }}</small>
              </template>


              <template #cell(services)="data">
                <!-- <span class="text-nowrap">{{ data.item.users.services ? data.item.users.services.name : '' }}</span> -->
                <span v-if="data.item.services"
                      class="font-weight-bold d-block text-nowrap">{{ data.item.services ? data.item.services.name : 'N/A' }}</span>

                <small class="text-muted" v-if="data.item.directions">{{ data.item.directions.name }}</small>

              </template>


              <template #cell(status)="data">
                <b-badge :variant="statusVariant(data.item.disabled)">
                  {{ data.item.disabled ? "Désactivé" : "Actif" }}
                </b-badge>
              </template>


              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <b-dropdown variant="link" toggle-class="p-0" no-caret>
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
                    </template>
                    <b-dropdown-item :to="{ name: 'ajouter-user', params: { id: data.item.id } }">
                      <edit-2-icon class="mr-50"/>
                      <span>Modifier</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="data.item.used"
                                     @click="deactivateUserHandler(data.item.id, !data.item.disabled)">
                      <ToggleLeftIcon class="mr-50"/>
                      <span>{{ data.item.disabled ? "Activer" : "Désactiver" }}</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-else @click="deleteUserHandler(data.item.id)">
                      <trash-icon class="mr-50"/>
                      <span>Supprimer</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card-body>

      <!-- Pagination -->
      <b-row class="align-items-center mx-0 mb-2">
        <!-- Bouton à gauche avec marge -->
<!--        <b-col cols="4" class="text-left">-->
<!--          <b-button class="ml-3 mr-1" variant="primary" @click="selectAllRows">-->
<!--            Valider-->
<!--          </b-button>-->
<!--        </b-col>-->

        <!-- Pagination centrée -->
        <b-col cols="12">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm" class="my-0"/>
          <p><span class="h3"> {{ totalRows }} </span> &nbsp; {{ totalRows > 1 ? 'Utilisateurs' : "Utilisateur" }} </p>
        </b-col>

        <!-- Colonne vide pour équilibrer -->
      </b-row>

    </b-card>

    <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="Télécharger" centered
             size="sm" title="Importer un fichier Excel" @ok="uploadFile">
      <div class="text-start">
        <label for="file-upload" class="mb-2">
          Sélectionnez un fichier Excel contenant la liste des utilisateurs avec les colonnes suivantes dans l'order
          : Matricule, Civilité, Nom, Prénom, Téléphone, Email, Date d'embauche, Fonction, Service, Direction,Type
          Direction,
          Role, Poste
          de péage et son Manager. </label>
        <b-form-file id="file-upload" v-model="selectedFile" accept=".xlsx, .xls" :state="Boolean(selectedFile)"
                     placeholder="Aucun fichier sélectionné" drop-placeholder="Déposez le fichier ici"
                     @change="validateFileType">
          <div v-if="!errorMessage" class="alert alert-danger ">
            {{ errorMessage }}
          </div>
        </b-form-file>

      </div>
    </b-modal>

  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import {
  getAllUsers,
  getAllUser,
  disableUser,
  deleteUsers,
  saveListUser,
  saveAllUserCheck,
  updateAutoEvaluationChecked,
  updateObjectifChecked,
  saveAllUserCheckAuto,
  saveAllUserCheckObj
} from "@/services/UserService";
import vSelect from 'vue-select';
import {Edit2Icon, TrashIcon, ToggleLeftIcon} from "vue-feather-icons";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as XLSX from "xlsx-js-style";
import {allServicesByDirections} from "@/services/ServicesService";
import {getAllDirectionsByActive} from "@/services/DirectionsService";
import {allPeagesActive} from "@/services/TollService";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    TrashIcon,
    vSelect,
    Edit2Icon,
    ToggleLeftIcon,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      filtreInclure: true, // Indique si l'utilisateur est inclus ou non
      filtreInclureAuto: true,
      disabled: true, // Indique si l'utilisateur est désactivé
      selectedFile: null, // Contient le fichier sélectionné
      isModalActive: false,
      perPage: 10,
      pageOptions: [3, 5, 10, 25, 50, 100, 200],
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      filter: null,
      active: false,

      disable: false,
      users: [],
      allUsers: [],
      allSelected: false,
      allSelectedAutoEvaluation: false,
      tableColumns: [
        {key: "objectif", label: "Objectif", sortable: false, class: "text-center"},
        {key: "evaluation", label: "Évaluation", sortable: false, class: "text-center"},

        {key: "user", label: "Nom Prénom(s)", sortable: true},
        {key: "fonction", label: "Fonction", sortable: true},

        {key: "services", label: "Services", sortable: true},
        {key: "status", label: "Statut", sortable: true},
        {key: "actions", label: "Actions"},
      ],
      selectedServices:null,
      selectedDirections:null,
      serviceOptions:[],
      directionOptions: [],
      selectedToll: null,
      tollOptions: [],
      errorMessage: '',

    };
  },
  computed: {
    statusVariant() {
      return (status) => (status ? "light-danger" : "light-primary");
    },
    sortOptions() {
      return this.tableColumns
          .filter((column) => column.sortable)
          .map((column) => ({text: column.label, value: column.key}));
    },

  },

  watch: {

    disabled(newVal) {
      this.fetchUsers();
    },
    filtreInclure(newVal) {
      this.fetchUsers();
    },
    filtreInclureAuto(newVal) {
      this.fetchUsers();
    },
    perPage(newVal, oldVal) {
      this.fetchUsers();
    },
    currentPage(newVal, oldVal) {
      this.fetchUsers()
    },
    selectedDirections(newVal, oldVal){
      this.onDirectionSelected(newVal)
      this.fetchUsers()
    },
    selectedServices(newVal, oldVal){
      this.onServiceSelected(newVal)
      this.fetchUsers()
    },
    selectedToll(newVal, oldVal){
      this.fetchUsers()
    }
  },
  methods: {
    async onDirectionSelected(direction) {

      if (direction && direction.id) {
        this.serviceOptions = await allServicesByDirections(direction.id);
      } else {
        // Si aucune direction sélectionnée → pas de service filtré
        this.serviceOptions = [];
        this.selectedServices = null;
      }
    },
    async onServiceSelected(service) {

      if (service && service.id && service.toll) {
        this.tollOptions = await allPeagesActive(service.toll);
      } else {
        // Si aucune direction sélectionnée → pas de service filtré
        this.tollOptions = [];
        this.selectedToll = null;
      }
    },
    async fetchOnDirection() {
      try {
        this.directionOptions = await getAllDirectionsByActive(true);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    onChangeObjectif(item) {
      updateObjectifChecked(item.id, item.checked).then(() => {
        this.showToast("Modification enregistrés avec succès.", "success");

      }).catch((error) => {
        console.error("Erreur lors de l'enregistrement des utilisateurs :", error);
        this.showToast("Échec de l'enregistrement des utilisateurs.", "danger");

      });
    },

    onChangeAutoEvaluation(item) {
      updateAutoEvaluationChecked(item.id, item.checkedAutoEvaluation).then(() => {
        this.showToast("Modification enregistrés avec succès.", "success");

      }).catch((error) => {
        this.showToast("Échec de l'enregistrement des utilisateurs.", "danger");

      });
    },


    selectAllRows() {
      let usersSelected;
      if (this.allSelected || this.allSelectedAutoEvaluation) {
        usersSelected = this.allUsers
      } else {
        usersSelected = this.users

      }

      saveAllUserCheck(usersSelected)
          .then(() => {
            this.showToast("Tous les utilisateurs sélectionnés ont été enregistrés avec succès.", "success");
            this.fetchUsers();
          })
          .catch((error) => {
            console.error("Erreur lors de l'enregistrement des utilisateurs :", error);
            this.showToast("Échec de l'enregistrement des utilisateurs.", "danger");
          });

    },
    async toggleAll() {
      this.users = this.users.map(u => ({
        ...u,
        checked: this.allSelected,
      }));

      saveAllUserCheckObj(this.allSelected,!this.disabled,this.filter).then(() => {
        this.showToast("Modification enregistrés avec succès.", "success");

      }).catch((error) => {
        console.error("Erreur lors de l'enregistrement des utilisateurs :", error);
        this.showToast("Échec de l'enregistrement des utilisateurs.", "danger");

      });
    },

    async toggleAllAutoE() {
      this.users = this.users.map(u => ({
        ...u,
        checkedAutoEvaluation :this.allSelectedAutoEvaluation,
      }));

      saveAllUserCheckAuto(this.allSelectedAutoEvaluation,!this.disabled,this.filter).then(() => {
        this.showToast("Modification enregistrés avec succès.", "success");

      }).catch((error) => {
        console.error("Erreur lors de l'enregistrement des utilisateurs :", error);
        this.showToast("Échec de l'enregistrement des utilisateurs.", "danger");

      });
    },


    validateFileType() {
      // if (!this.selectedFile) return;
      // const fileExtension = this.selectedFile?.name.split(".").pop().toLowerCase();
      // const validExtensions = ["xlsx", "xls"];

      // if (!validExtensions.includes(fileExtension)) {
      // this.selectedFile = null; // Réinitialiser le fichier
      // this.errorMessage="Le fichier sélectionné n'est pas un fichier Excel valide.";
      //   this.showToast("Le fichier sélectionné n'est pas un fichier Excel valide.", "danger");
      // }else{
      //   this.errorMessage='';
      // }
    }
    ,
    uploadFile() {
      const fileExtension = this.selectedFile?.name.split(".").pop().toLowerCase();
      const validExtensions = ["xlsx", "xls"];

      if (!validExtensions.includes(fileExtension)) {
        this.showToast('Veuillez sélectionner un fichier avant de continuer.', 'danger')

        return;
      }


      const reader = new FileReader();

      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, {type: "array"});

        // Lire la première feuille du fichier Excel
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convertir les données de la feuille Excel en JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1});

        // Vérifiez et traitez les données importées

        this.processData(jsonData);
      };
      reader.readAsArrayBuffer(this.selectedFile);


      // Traitez le fichier ici (par exemple, envoyez-le à un serveur ou lisez son contenu)
    },

    //async
    processData(data) {
      if (!data || data.length < 1) {
        this.showToast('Le fichier est vide ou mal formaté !', 'danger')

        return;
      }
      // Supprimez la ligne d'en-tête et traitez les autres lignes
      const [headers, ...rows] = data;


      // Exemple : Convertir les lignes en objets utilisateurs
      const users = rows.map((row) => ({
        matricule: row[0] || null,
        civilite: row[1] || null,

        lastName: row[2] || null,
        firstName: row[3] || null,
        telephone: row[4] || null,
        mail: row[5] || null,
        fonctionDate: row[6] ? this.excelDateToJSDate(row[6]) : null,
        fonction: row[7] || null,
        services: {
          name: row[8] || null,

        },
        directions: {
          name: row[9] || null,
          type: row[10] || null,

        },

        role: row[11] || null,
        toll: {
          name: row[12] || null,

        },
        usersHierarchique: [{
          lastName: row[13] || null,
          firstName: row[14] || null,
        }],


        // nomSuperieurHierarchique: row[9] || null,
        // prenomSuperieurHierarchique: row[10] || null,

      }));


      saveListUser(users)
          .then((users) => {

            this.fetchUsers();
            this.showToast("La liste des utilisateurs est enregistrée avec succès.", "success");
          })
          .catch((error) => {
            console.error("Erreur lors du chargement des utilisateurs :", error);
          });

    },
    excelDateToJSDate(excelDate) {
      // if(matricule==='00277'){

      const baseDate = new Date(1900, 0, 1); // Excel commence le 1er janvier 1900
      const jsDate = new Date(baseDate.getTime() + (excelDate - 2) * 24 * 60 * 60 * 1000); // Soustraire 2 à cause du bug Excel
      // Formatage pour "DD/MM/YYYY"
      const day = String(jsDate.getDate()).padStart(2, '0');
      const month = String(jsDate.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
      const year = jsDate.getFullYear();

      return `${day}-${month}-${year}`;
      // }
    },

    openAddModal() {

      this.isModalActive = true;
    },
    fetchUsers() {

      getAllUser(this.currentPage - 1, this.perPage, !this.disabled,
          this.filtreInclure, this.filtreInclureAuto, this.filter,
          this.selectedServices?.id,this.selectedDirections?.id,
          this.selectedToll?.id)
          .then((users) => {
            if (Array.isArray(users.user)) {
              this.users = users.user.map((user) => ({
                ...user,
                initials: this.getUserInitials(user),
              }));
              this.totalRows = users.count;
              if (this.users.length>0){
                this.allSelectedAutoEvaluation = this.users.every(u => u.checkedAutoEvaluation);
                this.allSelected = this.users.every(u => u.checked);
              }


            } else {
              console.error("Erreur : la réponse n'est pas un tableau", users);
            }
          })
          .catch((error) => {
            console.error("Erreur lors du chargement des utilisateurs :", error);
          });


    },
    getUserInitials(user) {
      if (!user) return "?";
      const firstInitial = user.firstName?.charAt(0).toUpperCase() || "";
      const lastInitial = user.lastName?.charAt(0).toUpperCase() || "";
      return `${lastInitial}${firstInitial}`
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async deactivateUserHandler(usersId, active) {
      try {
        const updatedUser = await disableUser(usersId, {
          disabled: active,
        });
        const row = this.users.find((r) => r.id === usersId);

        if (row) Object.assign(row, updatedUser);
        this.showToast(`Utilisateur ${active ? 'désactivé' : 'activé'} avec succès.`);

      } catch (error) {
        this.showToast(`Échec de la mise à jour du statut.`, "danger");

        console.error("Error updating data:", error);
      }
    },
    async deleteUserHandler(usersId) {
      try {
        await deleteUsers(usersId);
        this.users = this.users.filter((user) => user.id !== usersId);
        this.showToast("Utilisateur supprimé avec succès.", "success");

      } catch (error) {
        this.showToast("Échec lors de la suppression.", "danger");

        console.error("Error deleting data:", error);


      }
    },
    showToast(message, color) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckCircleIcon",
          variant: color,
        },
      });
    },

    exportUsers() {
      getAllUsers().then((users) => {
        if (!users || users.length === 0) {
          this.showToast("Aucun utilisateur à exporter", "danger");
          return;
        }

        this.showToast("Exportation en cours...", "success");
        const exportData = users.map(u => ({
          Matricule: u.matricule || "",
          Civilité: u.civilite || "",
          Nom: u.lastName || "",
          Prénom: u.firstName || "",
          Téléphone: u.telephone || "",
          Email: u.mail || "",
          fonctionDate: u.fonctionDate || "",
          Fonction: u.fonction || "",
          Service: u.services?.name || "",
          Direction: u.directions?.name || "",
          TypeDirection:  u.directions?.type || "",
          Role: u.role || "",
          Poste_Péage: u.toll?.name || "",
          Manager: (u.usersHierarchique && u.usersHierarchique.length > 0)
              ? u.usersHierarchique[0].fullName
              : "",
          Actif: u.disabled ? "Non" : "Oui",
        }));

        // Feuille de calcul
        const worksheet = XLSX.utils.json_to_sheet(exportData, { origin: "A2" });

        // Titre centré
        XLSX.utils.sheet_add_aoa(worksheet, [["LISTE DES UTILISATEURS"]], { origin: "A1" });

        worksheet["!merges"] = [{
          s: { r: 0, c: 0 },
          e: { r: 0, c: Object.keys(exportData[0]).length - 1 }
        }];

        worksheet["A1"].s = {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "center", vertical: "center" }
        };

        // Style des entêtes (gris + bordure)
        const headerRow = 1;
        const totalCols = Object.keys(exportData[0]).length;

        for (let c = 0; c < totalCols; c++) {
          const cellRef = XLSX.utils.encode_cell({ r: headerRow, c });

          if (worksheet[cellRef]) {
            worksheet[cellRef].s = {
              fill: { fgColor: { rgb: "D9D9D9" } },
              font: { bold: true },
              alignment: { horizontal: "center" },
              border: {
                top: { style: "thin", color: { rgb: "000000" }},
                bottom: { style: "thin", color: { rgb: "000000" }},
                left: { style: "thin", color: { rgb: "000000" }},
                right: { style: "thin", color: { rgb: "000000" }},
              }
            };
          }
        }

        // Bordures pour toutes les cellules
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let r = 2; r <= range.e.r; r++) {
          for (let c = 0; c < totalCols; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) continue;

            worksheet[cellRef].s = {
              ...worksheet[cellRef].s,
              border: {
                top: { style: "thin", color: { rgb: "000000" }},
                bottom: { style: "thin", color: { rgb: "000000" }},
                left: { style: "thin", color: { rgb: "000000" }},
                right: { style: "thin", color: { rgb: "000000" }},
              }
            };
          }
        }

        // Colonnes auto-ajustées
        worksheet["!cols"] = Object.keys(exportData[0]).map(col => ({
          wch: Math.max(col.length + 5,20)
        }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Utilisateurs");

        XLSX.writeFile(workbook, "Utilisateurs.xlsx");

        this.showToast("Exportation terminée ✅", "success");
      });
    }

  },
  //   computed: {
  //   utilisateursFiltres() {
  //     return this.users.filter(user => user.checked === this.filtreInclure);
  //   }
  // },
  mounted() {
    this.fetchOnDirection();
    this.fetchUsers();
  },
};
</script>

<style lang="scss" scoped>
.mb-1 {
  margin-bottom: 1rem;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>
